<template>
  <div
    class="card mt-3"
    :style="{ 'min-height': $store.state.screenHeight - 100 + 'px' }"
  >
    <div class="card-body text-center">
      <!-- <h1 style="font-weight: bold;">{{ title }}</h1> @change="getTransferAll(), getUserAll(), getProductAll(), getAll()" -->
      <div class="container">
        <div class="row">
          <div class="row col-4 pb-2">
            <label for="date" class="col-sm-3 col-form-label text-right pb-0">เลือกสาขา</label>
            <div class="col-sm-9 pb-0">
              <select
                class="custom-select mr-sm-2 pb-0"
                id="Branch"
                v-model="branch"
                @change="getTransferAll()"
              >
                <option value=0>-- ทุกสาขา --</option>
                <option
                  v-for="(b, i) in $store.state.branch_list"
                  :key="'branch' + i"
                  :value="b"
                  >{{ b.branch_name }}</option
                >
              </select>
              
            </div>
          </div>
          <div class="row col-8 pb-2">
            <label for="date" class="col-sm-2 col-form-label text-right pb-0">ค้นหา</label>
            <div class="col-sm-10 pb-0">
                <input
                  type="text"
                  class="form-control"
                  @keyup="onSearch"
                  v-model="search"
                  @keypress="onChange(1)"
                  placeholder="กรอกชื่อสินค้าหรือสถานะ...."
                />
            </div>
          </div>
          <div class="row col-4 pb-2">
              <label for="date" class="col-sm-3 col-form-label text-right">วันที่เริ่ม</label>
              <div class="col-sm-9 pb-0">
                <a-date-picker
                  v-model="startDate"
                  :format="'DD/MM/YYYY'"
                  style="width: 100%;"
                  :disabledDate="selectDateStart"
                  @change="onSerchDate"
                />
              </div>
          </div>
          <div class="row col-8 pb-2">
            <label for="date" class="col-sm-2 col-form-label text-right">ถึงวันที่</label>
              <div class="col-sm-5">
                <a-date-picker
                  v-model="endDate"
                  :format="'DD/MM/YYYY'"
                  style="width: 100%;"
                  :disabledDate="selectDateEnd"
                  @change="onSerchDate"
                />
              </div>
            <div class="col-sm-5 pb-0" style="text-align:left;">
              <button
                  type="button"
                  class="btn btn-primary"
                  style="width: 100%; background-color:#17a2b8; border-color:#17a2b8;"
                  @click="
                  modal_active_create = true;
                  modal_title_create = 'สั่งสินค้า';
                  "
                >
                <i class="fas fa-shopping-cart"></i> สั่งสินค้า
                </button>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th scope="col">#</th>
                <th scope="col">รหัสคำสั่งซื้อ</th>
                <th scope="col">เวลา</th>
                <th scope="col">รายการสินค้า</th>
                <th scope="col">หน่วยนับ</th>
                <th scope="col">จำนวน</th>
                <th scope="col">สาขาสั่งซื้อ</th>
                <th scope="col">สาขาที่โอนออก</th>
                <th scope="col">สถานะ</th>
                <th scope="col">ดำเนินการ</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(d, i) in paginate" :key="'cus' + i">
                <td class="text-center p-1">{{ i+1 }}</td>
                <td class="text-center p-1">{{ d.transfer_code }}</td>
                <td class="text-center p-1">
                  {{ d.transfer_date }}
                </td>
                <td class="text-right p-1">
                  <div v-for="(p, x) in d.product" :key="'product' + x">
                    <p style="text-align:left;" v-if="p.item !== null">{{ p.item.name }}</p>
                  </div>
                </td>
                <td class="text-right p-1">
                  <div v-for="(p, x) in d.product" :key="'product' + x">
                    <p style="text-align:left;" v-if="p.item !== null">{{ p.item.stk_unit_code }}</p>
                  </div>
                </td>
                <td class="text-left p-1">
                  <div v-for="(p, x) in d.product" :key="'product' + x">
                    <p style="text-align:center;">{{ p.amount }}</p>
                  </div>
                </td>
                <td class="text-center p-1">
                  {{ d.branch_in_name }}
                </td>
                <td class="text-center p-1">
                  {{ d.branch_out_name }}
                </td>
                <td class="text-center pb-1" :class="[d.status === 'PaddingWaiting' ? 'status-waiting' : d.status === 'Success' ? 'status-success' : d.status === 'Waiting' ? '' : 'status-success']">
                  {{ d.transfer_status }}
                </td>
                <td class="text-center p-1">
                  <button
                  type="button"
                  style="font-size: 20px;"
                  :class="['btn pt-0 pb-0 btn-warning-stock']"
                  @click="
                  modal_active = true;
                  modal_title = 'รายละเอียด';
                  modal_data = d
                  "
                >
                    <div >
                      <img src="../assets/pen.png" />

                    </div>
                </button>
                <button
                  type="button"
                  style="font-size: 20px;"
                  :class="['btn pt-0 pb-0 btn-danger']"
                  @click="
                  deleteItem(d)
                  "
                  v-if="d.status == 'Waiting'" 
                >
                  <i class="fas fa-trash"></i>
                </button>
                </td>
              </tr>
              <tr>
                <th
                  scope="row"
                  colspan="10"
                  class="text-center"
                  v-if="transfer_data.length < 1"
                >
                  ไม่มีข้อมูล
                </th>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          id="components-pagination-demo-mini"
          class="d-flex justify-content-end"
          v-if="transfer_data.length > items_perpage"
        >
          <a-pagination
            size="large"
            :total="transfer_data.length"
            :itemRender="itemRender"
            @change="onChange"
            v-model="currentPage"
          />
        </div>

        <a-modal
          :title="modal_title_create"
          centered
          v-model="modal_active_create"
          :footer="null"
          width="900px"
        >
          <div class="container p-0">
            <div class="container row" style="font-size:1rem;">
              <div class="col-sm-12" style="font-size:1.2rem;">เลือกสาขาที่สั่งซื้อ</div><br/>
              <div class="col-sm-12" style="font-size:1.2rem;">
                <div class="autocomplete">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="เลือกสาขา"
                    v-model="searchTerm"
                    @input="filterBranches"
                    @blur="closeDropdown"
                    @focus="openDropdown"
                    @keydown="handleKeydown"
                  />
                  <div
                    v-if="showDropdown"
                    class="autocomplete-dropdown"
                  >
                    <div
                      v-for="(b, i) in filteredBranches"
                      :key="'branch' + i"
                      :class="['autocomplete-item', { active: i === activeIndex }]"
                      @click="selectBranchCreate(b)"
                    >
                      {{ b.branch_name }}
                    </div>
                  </div>
                </div>
              </div><br/>
              <div class="col-sm-12" style="font-size:1.2rem;margin-top:8px;">เลือกสินค้า</div><br/>
              <div class="col-sm-12" style="font-size:1.2rem;">
                <div class="autocomplete">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="เลือกสินค้า"
                    v-model="searchTermItem"
                    @input="filterItems"
                    @blur="closeDropdownItem"
                    @focus="openDropdownItem"
                    @keydown="handleKeydownItem"
                  />
                  <div
                    v-if="showDropdownItem"
                    class="autocomplete-dropdown"
                  >
                    <div
                      v-for="(b, i) in filteredItems"
                      :key="'item' + i"
                      :class="['autocomplete-item', { active: i === activeIndexItem }]"
                      @click="selectItemCreate(b)"
                    >
                      {{ b.code + " " + b.name }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive pt-2 custom-table-container">
              <table class="table">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">รหัสสินค้า</th>
                    <th scope="col">รายการสินค้า</th>
                    <th scope="col">หน่วยนับ</th>
                    <th scope="col" class="text-center">จำนวน</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(d, i) in modal_data_items" :key="'cus' + i">
                    <td class="text-left p-1">
                      {{ i + 1 }}
                    </td>
                    <td class="text-left p-1">
                      {{ d.code }}
                    </td>
                    <td class="text-left p-1">
                      {{ d.name }}
                    </td>
                    <td class="text-left p-1">
                      {{ d.unit }}
                    </td>
                    <td class="text-center p-1">
                      <input
                        type="number"
                        style="text-align: right;"
                        v-model.number="d.amount"
                        class="form-control"
                        @focus="highlightValue($event)"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th
                      scope="row"
                      colspan="10"
                      class="text-center"
                      v-if="modal_data_items.length < 1"
                    >
                      ไม่มีข้อมูล
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
              <div
              class="container row mt-2"
              style="justify-content: center;"
              >
                <button
                  type="button"
                  class="btn btn-secondary"
          
                  @click="
                    modal_active_create = false;
                    searchTerm = ''
                    modal_data_items = []
                    "
                >
                  ยกเลิก
                </button>
                <button
                  type="button"
                  class="btn btn-primary ml-2"
                  @click="onSubmitData()">
                  ยืนยัน
                </button>
              </div>
            </div>
          </div>
        </a-modal>
      </div>
    </div>
    <a-modal
      :title="modal_title"
      centered
      v-model="modal_active"
      :footer="null"
      width="900px"
    >
      <div class="container p-1">
        <div class="container row" style="font-size:1rem;">
          <div class="col-sm-12" style="font-size:1.2rem;color:#7DC0FF;">{{modal_data.transfer_date}}</div><br/>
          <div class="col-sm-12">รหัสคำสั่งซื้อ {{ modal_data.transfer_code }}</div>
          <div class="col-sm-12">
            <span>สถานะ </span>
            <span :class="[modal_data.status === 'Cancel' ? 'status-cancel' : modal_data.status === 'Success' ? 'status-success' : modal_data.status === 'Waiting' ? '' : 'status-waiting']">
              {{ modal_data.transfer_status }}
            </span>
            <span v-if="modal_data.is_cancel_branch == 0 && modal_data.status == 'Cancel'"> (ส่วนกลาง) </span>
            <span v-if="modal_data.is_cancel_branch == 1 && modal_data.status == 'Cancel'"> ({{ modal_data.branch_in_name }}) </span>
          </div>
          <div class="col-sm-12" v-if="modal_data.status == 'Cancel'">
            <span>สาเหตุ </span>
            <span>{{ modal_data.remark }}</span>
          </div>
          <div class="col-sm-12">สาขาที่สั่งซื้อ {{ modal_data.branch_in_name }}</div>
          <div class="col-sm-12">สาขาที่โอนออก {{ modal_data.branch_out_name }} <span class="sending-success" v-if="modal_data.status == 'PaddingConfirm' || modal_data.status == 'Success'" >นำส่งแล้ว</span></div>
          <div class="table-responsive pt-2">
            <table class="table">
              <thead class="thead-dark">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">รหัสสินค้า</th>
                  <th scope="col">รายการสินค้า</th>
                  <th scope="col">หน่วยนับ</th>
                  <th scope="col" class="text-center">จำนวน</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, i) in modal_data.product" :key="'cus' + i">
                  <td class="text-left p-1">
                    {{ i+1 }}
                  </td>
                  <td class="text-left p-1">
                    {{ d.item.code }}
                  </td>
                  <td class="text-left p-1">
                    {{ d.item.name }}
                  </td>
                  <td class="text-left p-1">
                    {{ d.item.stk_unit_code }}
                  </td>
                  <td class="text-center p-1">
                    {{ d.amount }}
                  </td>
                </tr>
                <tr>
                  <th
                    scope="row"
                    colspan="10"
                    class="text-center"
                    v-if="modal_data.product.length < 1"
                  >
                    ไม่มีข้อมูล
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
         
          <div
          class="container row mt-2"
          style="justify-content: center;"
          v-if="modal_data.status != 'Cancel'"
          >
            <button
              type="button"
              class="btn btn-secondary"
              v-if="modal_data.status == 'PaddingWaiting'"
              @click="
                modal_cancel_active = true;
                modal_cancel.transfer_id = modal_data.transfer_id;
                modal_cancel.remark = ''
                remark = ''
                "
            >
              ยกเลิกคำสั่งซื้อ
            </button>
            <button
              type="button"
              class="btn btn-primary ml-2"
              v-if="modal_data.status == 'PaddingWaiting'"
              @click="onSubmitWaiting(modal_data.transfer_id)">
              อนุมัตินำส่ง
            </button>
            <button
              type="button"
              class="btn btn-primary ml-2"
              v-if="modal_data.status == 'PaddingConfirm'"
              @click="onSubmitConfirm(modal_data.transfer_id)">
              อนุมัตินำเข้า
            </button>
          </div>
        </div>
      </div>
    </a-modal>
    <a-modal
      title="แจ้งเตือน"
      centered
      v-model="modal_cancel_active"
      :footer="null"
      width="600px"
      >
        <h4>ยืนยันการยกเลิก <span style="color: red;"> * </span></h4>
        <textarea
          maxlength="500"
          class="form-control"
          placeholder="สาเหตุการยกเลิก..."
          v-model="modal_cancel.remark"
          @change="changeText()"
          rows="3"
        ></textarea>
        <span v-if="isEmpty" style="color: red; margin-top:0.5rem; margin-bottom:0.5rem;"> * กรุณากรอกสาเหตุการยกเลิก</span>
        <div
          class="container row mt-2"
          style="justify-content: center;"
        >
          <button
            type="button"
            class="btn btn-secondary"
            @click="
              modal_cancel_active = false;
              isEmpty=false
              "
          >
            ปิด
          </button>
          <button
            type="button"
            class="btn btn-primary ml-2"
            @click="cancelTransfer()">
            ยืนยัน
          </button>
        </div>
      </a-modal>
  </div>

  

</template>

<script>
/* eslint-disable camelcase */
// import apiCus from '../services/service_customer'
// import apiItem from '../services/service_item.js'
import apiCenterV2 from "../services/service_undefined_v2";
import Swal from 'sweetalert2'
import moment from 'moment'
import dayjs from 'dayjs'
import buddhistEra from 'dayjs/plugin/buddhistEra';
dayjs.extend(buddhistEra);

export default {
  data () {
    return {
      transfer_data: [],
      transfer_search: [],
      form_data: "",
      cus_age: 0,
      startDate: moment(new Date()).startOf('month'),
      endDate: moment(new Date()).endOf('month'),
      orderDate: moment(new Date()).format("DD/MM/YYYY HH:mm:ss"),
      orderStatus: 1,
      last_date: new Date(),
      title: 'ปรับปรุงสินค้า',
      search: '',
      currentPage: 1,
      items_perpage: 10,
      modal_cancel_active: false,
      modal_active: false,
      modal_active_create: false,
      isEmpty: false,
      searchTerm: "", // Search term for filtering
      searchTermItem: "", // Search term for filtering
      filteredBranches: [], // Filtered list of branches
      filteredItems: [], // Filtered list of branches
      filteredItemsSearch: [], // Filtered list of branches
      showDropdown: false, // Dropdown visibility
      showDropdownItem: false, // Dropdown visibility
      activeIndex: -1, // Active index for keyboard navigation
      activeIndexItem: -1, // Active index for keyboard navigation
      modal_cancel:{
        transfer_id: '',
        remark: ''
      },
      modal_data: {
        transfer_code: '',
        transfer_date: moment(new Date).format("DD/MM/YYYY HH:mm:ss"),
        date: new Date(),
        transfer_id: '',
        branch_out_name: '',
        branch_in_id: '',
        branch_in_name: '',
        remark: '',
        is_cancel_branch: 0,
        transfer_status: '',
        status: '',
        product: ''
      },
      modal_data_items: [],
      modal_title: '',
      modal_title_create: '',
      list_bill: [],
      data_ap: [],
      data_rp: [],
      modal_item_active: false,
      data_item: [],
      unit: [],
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      branch: "0",
      branchItem: "0",
      branchOut: "0",
      branch_out_list: [],
      branchOutError: false,
      items: []
    }
  },
  computed: {
 
    paginate: function () {
      this.totalItem = this.transfer_data.length
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1)
      }
      var index = (this.currentPage - 1) * this.items_perpage
      return this.transfer_data.slice(index, index + this.items_perpage)
    }
  },
  watch: {
    branch (newValue) {
      if (!newValue) this.searchTerm = ""; // Clear search when branch is reset
    },
    item (newValue) {
      if (!newValue) this.searchTermItem = ""; // Clear search when branch is reset
    },
  },
  methods: {
    onSubmitWaiting (event) {
      Swal.fire({
        title: "แจ้งเตือน",
        text: "ยืนยันอนุมัติโอนย้ายสินค้า",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ปิด",
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          this.$store.commit("Loading");
          apiCenterV2.approveOutTransfer(
          {
            transfer_id: event
          },
          this.header,
          results => {
            this.transfer_data = []
            if (results.data.status) {
              this.$notification["success"]({
                message: "แจ้งเตือน",
                description: "โอนย้ายสินค้าสำเร็จ"
              });
              // eslint-disable-next-line padded-blocks
              this.getTransferAll()
              this.modal_active = false
            }
            this.$store.commit("Loading");
          },
            errors => {
              this.$store.commit("Loading");
              this.$notification["warning"]({
                message: "โอนย้ายสินค้าไม่สำเร็จ",
                description: errors.data.message
              });
            }
          );
        } else {
          // this.modal_active = false
        }
      })
    },
    onSubmitConfirm (event) {

      Swal.fire({
        title: "แจ้งเตือน",
        text: "ยืนยันอนุมัตินำเข้าสินค้า",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ปิด",
        reverseButtons: true
      }).then(result => {
        if (result.value) {
        this.$store.commit("Loading");
        apiCenterV2.approveInTransfer(
        {
          transfer_id: event
        },
        this.header,
        results => {
          this.transfer_data = []
          if (results.data.status) {
            this.$notification["success"]({
              message: "แจ้งเตือน",
              description: "นำเข้าสำเร็จ"
            });
            // eslint-disable-next-line padded-blocks
            this.getTransferAll()
            this.modal_active = false
          }
          this.$store.commit("Loading");
        },
          errors => {
            this.$store.commit("Loading");
            this.$notification["warning"]({
              message: "นำเข้าสำเร็จไม่สำเร็จ",
              description: errors.data.message
            });
          }
        );
        } else {
          // this.modal_active = false
        }
      })
    },
    onSubmitData () {
      if(this.searchTerm !== "" && this.modal_data_items.length > 0) {
        const hasInvalidAmount = this.modal_data_items.some(item => item.amount === 0 || item.amount === "");
        if (hasInvalidAmount) {
          Swal.fire({
            icon: "error",
            title: "จำนวนสินค้าต้องมากกว่า 0",
            showConfirmButton: false,
            timer: 2000
          });
          console.log("There is at least one item with amount equal to 0.");
        } else {
          Swal.fire({
            title: "แจ้งเตือน",
            text: "ยืนยันอนุมัติคำสั่งซื้อ",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ปิด",
            reverseButtons: true
          }).then(result => {
            if (result.value) {
            this.$store.commit("Loading");
            apiCenterV2.insertWaitingTransferStock(
            {
              branchName: this.searchTerm,
              product: this.modal_data_items
            },
            this.header,
            results => {
              this.transfer_data = []
              if (results.data.status) {
                this.$notification["success"]({
                  message: "แจ้งเตือน",
                  description: "คำสั่งซื้อสำเร็จ"
                });
                // eslint-disable-next-line padded-blocks
                this.getTransferAll()
                this.modal_active_create = false
              }
              this.$store.commit("Loading");
            },
              errors => {
                this.$store.commit("Loading");
                this.$notification["warning"]({
                  message: "คำสั่งซื้อไม่สำเร็จ",
                  description: errors.data.message
                });
              }
            );
            }
          })
        }
      }
    },
    highlightValue (event) {
      // Select all the text inside the input
      event.target.select();
    },
    onSearch () {
      if (this.search === '') {
        this.transfer_data = this.transfer_search
      } else {
        this.transfer_data = this.transfer_search.filter(e => e.transfer_code.includes(this.search) || e.transfer_status.includes(this.search) || e.product.filter(p => { if (p.item.name != null) { if (p.item.name.includes(this.search)) return p } }).length > 0)
        // console.log(this.branch)
        // if(this.branch.includes(this.search)
      }
      this.onChange(1)
    },
    onSerchDate () {
      // console.log(new Date(this.startDate).setUTCHours(0,0,0,0))
      this.getTransferAll();
      // this.transfer_data = this.transfer_search.filter(e =>
      // new Date(e.date).setHours(0,0,0,0) >= new Date(this.startDate).setHours(0,0,0,0)
      // && new Date(e.date).setHours(0,0,0,0) <= new Date(this.endDate).setHours(0,0,0,0))
      // this.onChange(1)
    },
    changeText () {
      // console.log(this.modal_cancel.remark)
      if (this.modal_cancel.remark === '') {
        this.isEmpty = true
      } else {
        this.isEmpty = false
      }
    },
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    onChange (pageNumber) {
      this.currentPage = pageNumber
    },
    // getHaveStock () {
    //   apiCenterV2.getHaveStock(
    //     {
    //       transfer_id: this.modal_data.transfer_id
    //     },
    //     this.header,
    //     results => {
    //       if(results.data.status){
    //         this.branch_out_list = results.data.data
    //       }
    //     },
    //     errors => {
    //     })
    // },
    filterBranches () {
      const term = this.searchTerm.toLowerCase();
      this.filteredBranches = this.$store.state.branch_list.filter((branch) =>
        branch.branch_name.toLowerCase().includes(term)
      );
    }, 
    filterItems () {
      const term = this.searchTermItem.toLowerCase();
      this.filteredItems = this.filteredItemsSearch.filter((item) =>
        item.name.toLowerCase().includes(term) || item.code.toLowerCase().includes(term)
      );
    },
    selectBranch (branch) {
      this.branch = branch; // Set selected branch
      // this.searchTerm = branch.branch_name; // Update search input
      // this.showDropdown = false; // Close dropdown
      this.getTransferAll(); // Call the change handler
    },
    selectBranchCreate (branch) {
      // this.branch = branch; // Set selected branch
      this.searchTerm = branch.branch_name; // Update search input
      // this.branchItem = branch.id
      this.showDropdown = false; // Close dropdown
      this.modal_data_items = []
      this.searchTermItem = ""
      this.getProductAll(branch.id);
      // this.getTransferAll(); // Call the change handler
    },
    selectItemCreate (item) {
      // this.branch = branch; // Set selected branch
      const existingItemIndex = this.modal_data_items.findIndex(
        (existingItem) => existingItem.id === item.id
      );

      if (existingItemIndex === -1) {
        // Add the new item if it doesn't already exist
        this.modal_data_items.push({
          id: item.id,
          code: item.code,
          name: item.name,
          unit: item.stk_unit_code,
          amount: 0,
        });
      }
      // this.showDropdownItem = false; // Close dropdown
      // this.getTransferAll(); // Call the change handler
    },
    openDropdown () {
      this.showDropdown = true;
      this.searchTerm = ""
      this.modal_data_items = []
    },
    closeDropdown () {
      setTimeout(() => {
        this.showDropdown = false;
      }, 100); // Delay to allow click event to complete
    },
    openDropdownItem () {
      this.showDropdownItem = true;
    },
    closeDropdownItem () {
      setTimeout(() => {
        this.searchTermItem = ""
        this.showDropdownItem = false;
      }, 100); // Delay to allow click event to complete
    },
    handleKeydown (event) {
      this.showDropdownItem = false;
      if (!this.showDropdown || this.filteredBranches.length === 0) return;

      switch (event.key) {
        case "ArrowDown":
          event.preventDefault();
          this.activeIndex =
            (this.activeIndex + 1) % this.filteredBranches.length;
          break;

        case "ArrowUp":
          event.preventDefault();
          this.activeIndex =
            (this.activeIndex - 1 + this.filteredBranches.length) %
            this.filteredBranches.length;
          break;

        case "Enter":
          event.preventDefault();
          if (this.activeIndex >= 0 && this.activeIndex < this.filteredBranches.length) {
            this.selectBranchCreate(this.filteredBranches[this.activeIndex]);
          }
          break;

        case "Escape":
          this.showDropdown = false; // Close dropdown
          break;
      }
    },
    handleKeydownItem (event) {
      this.showDropdown = false;
      // console.log(event.key);
      if (!this.showDropdownItem || this.filteredItems.length === 0) return;
   
      switch (event.key) {
        case "ArrowDown":
          event.preventDefault();
          this.activeIndexItem =
            (this.activeIndexItem + 1) % this.filteredItems.length;
          break;

        case "ArrowUp":
          event.preventDefault();
          this.activeIndexItem =
            (this.activeIndexItem - 1 + this.filteredItems.length) %
            this.filteredItems.length;
          break;

        case "Enter":
          event.preventDefault();
          if (this.activeIndexItem >= 0 && this.activeIndexItem < this.filteredItems.length) {
            this.selectItemCreate(this.filteredItems[this.activeIndexItem]);
          }
          break;

        case "Escape":
          this.showDropdownItem = false; // Close dropdown
          break;
      }
    },
    getProductAll (event) {
      this.$store.commit("Loading");
      apiCenterV2.getProductAll(
        {
          branch_id: event.toString()
        },
        this.header,
        results => {
          
          if (results.data.status) {
            this.filteredItems = JSON.parse(JSON.stringify(results.data.data));
            this.filteredItemsSearch = JSON.parse(JSON.stringify(results.data.data));
          } else {
            this.$notification["warning"]({
              message: "ไม่สามารถดึงข้อมูลจากระบบได้",
              description: ""
            });
          }
          
          this.$store.commit("Loading");
        },
        errors => {
          console.log(errors);
          this.$store.commit("Loading");
          this.$notification["warning"]({
            message: "ไม่สามารถดึงข้อมูลจากระบบได้",
            description: errors.data.message
          });
        }
      );
    },
    getTransferAll () {
      let branchId = 0
      if (this.branch === "0") {
        branchId = 0;
      } else {
        branchId = this.branch.id
      }
      this.$store.commit("Loading");
      apiCenterV2.selectTransferBranch(
        {
          branch_id: branchId.toString(),
          startDate: this.startDate,
          endDate: this.endDate
        },
        this.header,
        results => {
          this.transfer_data = []
          this.transfer_search = []
          
          if (results.data.status) {
            // eslint-disable-next-line padded-blocks
            results.data.data.forEach(val => {
              let status = val.transfer.transfer_status === 'PaddingWaiting' ? 'รอยืนยันนำส่ง' : 'รอยืนยันรับสินค้า';
              this.transfer_data.push({
                transfer_id: val.transfer.id,
                transfer_code: val.transfer.transfer_code,
                transfer_date: dayjs(val.transfer.transfer_date).format('DD/MM/BBBB HH:mm:ss'),
                date: val.transfer.transfer_date,
                branch_out_name: val.transfer.branch_out_name,
                branch_in_id: val.transfer.branch_in_id,
                branch_in_name: val.transfer.branch_in_name,
                remark: val.transfer.remark,
                is_cancel_branch: val.transfer.is_cancel_branch,
                transfer_status: status,
                status: val.transfer.transfer_status,
                // isEdit: edit,
                product: val.transfer_product.transfer_stock_products
              })
              this.transfer_search.push({
                transfer_id: val.transfer.id,
                transfer_code: val.transfer.transfer_code,
                transfer_date: dayjs(val.transfer.transfer_date).format('DD/MM/BBBB HH:mm:ss'),
                date: val.transfer.transfer_date,
                branch_out_name: val.transfer.branch_out_name,
                branch_in_id: val.transfer.branch_in_id,
                branch_in_name: val.transfer.branch_in_name,
                remark: val.transfer.remark,
                is_cancel_branch: val.transfer.is_cancel_branch,
                transfer_status: status,
                status: val.transfer.transfer_status,
                // isEdit: edit,
                product: val.transfer_product.transfer_stock_products
              })
            })
            this.onSearch()
            this.form_data = JSON.stringify(this.transfer_data);
            this.totalItem = this.transfer_data.length
          } else {
            this.$notification["warning"]({
              message: "ไม่สามารถดึงข้อมูลจากระบบได้",
              description: ""
            });
          }
          this.$store.commit("Loading");

          this.filteredBranches = this.$store.state.branch_list;

 
        },
        errors => {
          console.log(errors);
          this.$store.commit("Loading");
          this.$notification["warning"]({
            message: "ไม่สามารถดึงข้อมูลจากระบบได้",
            description: errors.data.message
          });
        }
      );
    },
    selectDateStart (current) {
      return current && current.valueOf() > this.endDate;
    },
    selectDateEnd (current) {
      return current && current.valueOf() < this.startDate;
    },
    deleteItem (val) {

      Swal.fire({
        title: "ยกเลิกสั่งซื้อสินค้า",
        text: "ท่านต้องการยกเลิกสั่งซื้อสินค้า ใช่หรือไม่ ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
        cancelButtonColor: "red",
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          this.$store.commit("Loading");
          apiCenterV2.cancelTransferStockWhenApprove(
            {
              transfer_id: val.transfer_id,
              remark: 'โอนสต๊อกผิดพลาด'
            },
            this.header,
            results => {
              // console.log(results);
              if (results.data.status) {
                this.alert_msg("success", "ยกเลิกสำเร็จ", "");
                // this.getProductAll();
                this.getTransferAll();
              } else {
                this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", "");
              }
              this.$store.commit("Loading");
            },
            errors => {
              this.$store.commit("Loading");
              // this.$store.commit("Loading");
              this.alert_msg(
                "warning",
                "ไม่สามารถเข้าถึงข้อมูล",
                errors.message
              );
            }
          );
        }
      });
    },
    cancelTransfer () {
      if(this.modal_cancel.remark === '') {
        this.isEmpty = true;
      } else {
        this.isEmpty = false;
        this.$store.commit("Loading");
        apiCenterV2.cancelTransferStock(
        {
          remark: this.modal_cancel.remark,
          transfer_id: this.modal_cancel.transfer_id
        },
        this.header,
        results => {
          this.transfer_data = []
          if (results.data.status) {
            this.$notification["success"]({
              message: "แจ้งเตือน",
              description: "ยกเลิกคำสั่งซื้อสำเร็จ"
            });
            // eslint-disable-next-line padded-blocks
            this.getTransferAll()
            this.modal_cancel_active = false
            this.modal_active = false
          }
          this.$store.commit("Loading");
        },
          errors => {
            this.$store.commit("Loading");
            this.$notification["warning"]({
              message: "ยกเลิกคำสั่งซื้อไม่สำเร็จ",
              description: errors.data.message
            });
          }
        );
      }

    },
  },
  created () {
    this.getBranch()
    this.getTransferAll()
  },
  mounted () {
  }
}
</script>
<style scoped>
#components-pagination-demo-mini .ant-pagination:not(:last-child) {
  margin-bottom: 24px;
}
.status-waiting {
  color: #FFCA2B;
}

.status-success {
  color: #359E39;
}

.status-cancel {
  color: #DE4554;
}

.btn-warning-stock {
  background-color: #FFC201;
}

.btn-secondary-stock {
  background-color: #DFE3E7;
}


.sending-success {
  background-color: #359E39;
  color: white;
  border:1px solid #359E39;
  font-size: 0.875rem;
  padding: 2px 4px;
  border-radius: 0.5rem;
}
.autocomplete {
  position: relative;
  width: 100%;
}
.autocomplete-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
}
.autocomplete-item {
  padding: 8px 12px;
  cursor: pointer;
}
.autocomplete-item:hover {
  background: #f0f0f0;
}

.custom-table-container {
  margin-top: 16px;
  max-height: 200px; /* Set the max height of the table */
  overflow-y: scroll; /* Always show vertical scroll */
  scrollbar-width: auto; /* Use the default width for non-WebKit browsers */
  scrollbar-color: auto; /* Retain the default scrollbar color */
}

.custom-table-container::-webkit-scrollbar {
  width: 10px; /* Set the width of the scrollbar */
}

.custom-table-container::-webkit-scrollbar-thumb {
  background-color: #cccccc; /* Optional: Set the color of the scrollbar thumb */
  border-radius: 5px; /* Optional: Make the scrollbar thumb rounded */
}

.custom-table-container::-webkit-scrollbar-track {
  background-color: #f1f1f1; /* Optional: Set the background color of the track */
}
</style>



// WEBPACK FOOTER //
// src/views/stock_get_manage.vue